import { FC } from 'react';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';

const { RangePicker } = DatePicker;

export type PeriodRange = [Moment, Moment];

interface PeriodPickerProps {
  value: PeriodRange | null;
  onChange: (range: PeriodRange | null) => void;
}

// Quick presets, matching the range picker used on the other profile tabs.
const RANGES: Record<string, [Moment, Moment]> = {
  'This month': [moment().startOf('month'), moment().endOf('month')],
  'Last 30 days': [moment().subtract(29, 'days'), moment()],
  'This week': [moment().startOf('week'), moment().endOf('week')],
};

const PeriodPicker: FC<PeriodPickerProps> = ({ value, onChange }) => (
  <RangePicker
    size="large"
    allowClear={false}
    format="MM/DD/YYYY"
    value={value as any}
    ranges={RANGES}
    onChange={(range: any) => {
      if (range && range[0] && range[1]) {
        onChange([range[0], range[1]]);
      } else {
        onChange(null);
      }
    }}
  />
);

export default PeriodPicker;

/** Default range: the current week. */
export const defaultPeriod: PeriodRange = [moment().startOf('week'), moment().endOf('week')];
